import { all, call } from 'redux-saga/effects';

import { sagas as updateSagas } from './updateModule';
import { sagas as detailsSagas } from './detailsModule';

export default function* authSagas() {
	yield all([call(updateSagas), call(detailsSagas)]);
}
